export default "__VITE_ASSET__DFhI5R9L__"